import type { LocalizedDict } from '../index'

export type SpecsEditorStrings = {
  types: Record<'color' | 'size' | 'custom', string>
  typeChip: (type: string) => string
  placeholders: { color: string; size: string; other: string }
  material: string
  selectMaterial: string
  add: string
  edit: (type: string) => string
  remove: (type: string) => string
  label: string
  save: string
  removeRow: string
}

const CHIP_TR: Record<string, string> = { color: 'renk', size: 'ölçü', custom: 'özel' }

export const specsEditorI18n: LocalizedDict<SpecsEditorStrings> = {
  en: {
    types: { color: 'Color', size: 'Size', custom: 'Custom' },
    typeChip: (type) => type,
    placeholders: { color: 'e.g. Black, Tan, Cognac', size: 'e.g. 20×15×5 cm', other: 'Value' },
    material: 'Material',
    selectMaterial: '— Select material —',
    add: '+ Add:',
    edit: (type) => `Edit ${type}`,
    remove: (type) => `Remove ${type}`,
    label: 'Label',
    save: 'Save',
    removeRow: 'Remove',
  },
  tr: {
    types: { color: 'Renk', size: 'Ölçü', custom: 'Özel' },
    typeChip: (type) => CHIP_TR[type] ?? type,
    placeholders: { color: 'ör. Siyah, Taba, Konyak', size: 'ör. 20×15×5 cm', other: 'Değer' },
    material: 'Malzeme',
    selectMaterial: '— Malzeme seç —',
    add: '+ Ekle:',
    edit: (type) => `${CHIP_TR[type] ?? type} düzenle`,
    remove: (type) => `${CHIP_TR[type] ?? type} kaldır`,
    label: 'Etiket',
    save: 'Kaydet',
    removeRow: 'Kaldır',
  },
}
